import React, { useState } from 'react'
import { QRCodeDisplay, Step1, SuccessBox } from './components/Steps'
import { BackIcon, chalkwidettx, newlogo } from '../../../../../../assets/icons'
import { Typography } from '@mui/material'
import './Registration.css'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { usePostApi } from '../../../../../../shared'
import { getImageURL, urls } from '../../../../../../shared/config'
import { uploadImageToS3 } from '../../../../../../shared/config/S3Utils'
import { useNavigate } from 'react-router-dom'
import { setLoader } from '../../../../../../redux/globalSlice'
import { useDispatch } from 'react-redux'

const SchoolRegistration = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [success, setsuccess] = useState(false)
  const [step, setStep] = useState(1)
  const { postApi } = usePostApi()
  const [empId, setEmpId] = useState()
  const [qrOpen, setOpenQR] = useState(false)

  const initialValues = {
    schoolName: '',
    contactNumber: '',
    adName: '',
    gender: '',
    personalcontact: '',
    personalAddress1: '',
    personalAddress2: '',
    personalEmail: '',
    personalCity: '',
    personalState: '',
    personalZip: '',
    teacherName: '',
    teacherQual: '',
    teacherDOB: '',
    teachergender: '',
    teacherContact: '',
    teacherEContact: '',
    teacherEmail: '',
    teacherSalary: '',
    teacherJoiningDate: '',
    teacherAddress1: '',
    teacherAddress2: '',
    teacherCity: '',
    teacherState: '',
    teacherZip: '',
    grade: '',
    section: '',
    sectionGrade: '',
    primaryTeacher: '',
    secTeacher: '',
    supportStaff: '',
    personalImage: null,
    administrationImage: null,
    teacherImage: null,
    salary: '',
    joiningDate: '',
    school_timing: '',
    school_staff_timing: '',
    school_fee_method: 'Monthly',
    password: '',
    school_address: '',
    school_city: '',
    school_state: '',
    school_pin_code: '',
    is_partner: false,
    school_country_code: '+91',
    employee_country_code: '+91',
    school_country: 'India',
  }

  const validationSchema = Yup.object({
    schoolName: Yup.string().required('School Name is required!'),
    contactNumber: Yup.string().required('School Phone Number is required!'),
    adName: Yup.string().required('Admin Name is required!'),
    personalcontact: Yup.string().required('Admin Phone Number is required!'),
    personalEmail: Yup.string().required('Admin Email is required!'),
    salary: Yup.string().required('Salary is required'),
    joiningDate: Yup.string().required('Joining Date is required'),
    password: Yup.string().required('Password is required'),
  })
  const handleSubmit = () => {
    dispatch(setLoader(true))
    validationSchema
      .validate(formik.values, { abortEarly: false })
      .then(async () => {
        if (formik.values.schoolName && formik.values.schoolName.length < 2) {
          toast.error('School name must be at least 2 characters!')
          dispatch(setLoader(false))
          return
        }
        if (formik.values.personalZip && formik.values.personalZip.length > 6) {
          toast.error('Zipcode must be 6 digits!')
          dispatch(setLoader(false))
          return
        }
        if (
          !/^\d{10}$/.test(formik.values.contactNumber) ||
          formik.values.contactNumber.startsWith('0')
        ) {
          toast.error('Invalid School Phone Number!')
          dispatch(setLoader(false))
          return
        }

        if (
          !/^\d{10}$/.test(formik.values.personalcontact) ||
          formik.values.personalcontact.startsWith('0')
        ) {
          toast.error('Invalid Admin Phone Number!')
          dispatch(setLoader(false))
          return
        }

        if (formik.values.personalImage) {
          await uploadImageToS3(formik.values.personalImage, 'school')
        }
        if (formik.values.administrationImage) {
          await uploadImageToS3(formik.values.administrationImage, 'school')
        }
        const responseBody = {
          school_name: formik.values.schoolName,
          school_contact_number: formik.values.contactNumber,
          ...(formik.values.personalImage
            ? { school_avatar: getImageURL('school', formik.values.personalImage.name) }
            : {}),
          employee_name: formik.values.adName,
          employee_email: formik.values.personalEmail,
          employee_salary: formik.values.salary,
          employee_joining_date: formik.values.joiningDate,
          school_staff_timing: formik.values.school_staff_timing,
          school_timing: formik.values.school_timing,
          employee_gender: formik.values.gender,
          employee_contact_number: formik.values.personalcontact,
          ...(formik.values.administrationImage
            ? { employee_avatar: getImageURL('school', formik.values.administrationImage.name) }
            : {}),
          ...(formik.values.personalAddress1
            ? { employee_address: formik.values.personalAddress1 }
            : {}),
          ...(formik.values.personalAddress2
            ? { employee_address_two: formik.values.personalAddress2 }
            : {}),
          ...(formik.values.personalCity ? { employee_city: formik.values.personalCity } : {}),
          ...(formik.values.personalState ? { employee_state: formik.values.personalState } : {}),
          ...(formik.values.personalZip ? { employee_pincode: formik.values.personalZip } : {}),
          school_fee_method: formik.values.school_fee_method,

          employee_type: 'Admin',
          employee_password: formik.values.password,
          school_address: formik.values.school_address,
          school_city: formik.values.school_city,
          school_state: formik.values.school_state,
          school_pin_code: formik.values.school_pin_code,
          is_partner: !!formik.values.is_partner,
          school_country_code: formik.values.school_country_code,
          employee_country_code: formik.values.employee_country_code,
          school_country: formik.values.school_country,
        }

        postApi(urls.SCHOOL_POST, responseBody)
          .then((response) => {
            if (response.status == 201 || response.status == 200) {
              const { employee_id } = response.data
              setEmpId(employee_id)
              setsuccess(true)
              toast.success('Section Added Successfully!')
              dispatch(setLoader(false))
            } else {
              toast.error(response.message)
              dispatch(setLoader(false))
            }
          })

          .catch((error) => {
            if (error instanceof Yup.ValidationError) {
              error.inner.forEach((err) => {
                toast.error(err.message)
              })
            } else {
              toast.error('An error occurred while submitting the form.')
            }
            dispatch(setLoader(false))
          })
      })
      .catch((errors) => {
        if (errors instanceof Yup.ValidationError) {
          errors.inner.forEach((err) => {
            toast.error(err.message)
          })
        }
        dispatch(setLoader(false))
      })
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  })

  const handlePrev = () => {
    if (step > 1) {
      setStep((prevStep) => prevStep - 1)
    }
  }
  const handleFileChange = (event, fieldName) => {
    const selectedFile = event.target.files[0]
    formik.setFieldValue(fieldName, selectedFile)
  }

  return (
    <div className="registration-container">
      {/* <ToastContainer /> */}
      <div className="logo-cont">
        <img src={newlogo} alt="" />
        <img src={chalkwidettx} alt="" />
      </div>

      {!success && (
        <div className="registration-box">
          <div className="header-registration">
            <div className="download-block" onClick={() => navigate('/dashboard')}>
              <img src={BackIcon} alt="" className="back-icon" />
              Back
            </div>
          </div>
          <Typography className="reg-title">School Registration</Typography>

          <Step1
            formik={formik}
            onPrev={handlePrev}
            onNext={handleSubmit}
            handleFileChange={handleFileChange}
          />
        </div>
      )}
      {success && <SuccessBox formik={formik} handleQR={() => setOpenQR(true)} />}
      {qrOpen && (
        <QRCodeDisplay
          name={formik.values.schoolName}
          open={qrOpen}
          value={empId}
          handleClose={() => setOpenQR(false)}
        />
      )}
    </div>
  )
}

export default SchoolRegistration
